import { render } from "./pricing-selection.vue?vue&type=template&id=6f67eb20&ts=true"
import script from "./pricing-selection.ts?vue&type=script&lang=ts&external"
export * from "./pricing-selection.ts?vue&type=script&lang=ts&external"

import "./pricing-selection.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__